import { useEffect, useState } from 'react';
import type { Session } from '@supabase/supabase-js';
import { getSupabase } from '@/lib/supabase';

export interface AuthState {
  session: Session | null;
  status: 'loading' | 'authenticated' | 'unauthenticated';
}

export function useAuth(): AuthState {
  const [state, setState] = useState<AuthState>({ session: null, status: 'loading' });

  useEffect(() => {
    const supabase = getSupabase();
    let mounted = true;

    supabase.auth.getSession().then(({ data }) => {
      if (!mounted) return;
      setState({
        session: data.session,
        status: data.session ? 'authenticated' : 'unauthenticated',
      });
    });

    const { data: sub } = supabase.auth.onAuthStateChange((_evt, session) => {
      setState({ session, status: session ? 'authenticated' : 'unauthenticated' });
    });

    return () => {
      mounted = false;
      sub.subscription.unsubscribe();
    };
  }, []);

  return state;
}
